/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
import React, { useState, useContext, useEffect } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PsychometricService from "../../services/PsychometricService";
import { ThemeContext } from "../../contexts/ThemeContext";
import PsychometricContext from "../../contexts/PsychometricContext";
const PsychometricPDFReport = () => {
  const { theme } = useContext(ThemeContext);
 const {signedEmail, signedOrganization, signedMobile, signedID, signedFirstName, signedLastName} = useContext(PsychometricContext);
  const pdfRef = React.createRef();
  const [userData, setUserData] = useState(null);
  const fetchUserData = async () => {
    console.log("fetch attempt 1");
    
    try {
      const response = await PsychometricService.getPsychometricUser(
       signedID,
       signedFirstName,
       signedLastName,
        signedOrganization,
   
      );

      setUserData(response.user);

    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const generatePdf = async () => {
    console.log("generation attempt");
    let doc = new jsPDF();
    let elementHTML = document.getElementById('pdfdoc');
   
    doc.html(elementHTML, {
        callback: async function (doc) {
          // generate PDF and send email
          const pdfData = doc.output('blob');
       
          try {
            const response = await PsychometricService.sendReport(userData.uniqueID, userData.firstName, userData.lastName, userData.organization, pdfData);
         
          } catch (error) {
            console.error("Error sending report:", error);
          }
        },
    })
  };

  return (
    <main>
      <div>
      {userData && (
          <>
            <button onClick={generatePdf}>Generate PDF</button>
            
          </>
        )}
      </div>
      <div>
        <br />
        <div style={{ overflow: "auto", alignSelf: "center" }}>
          <div
            style={{ position: "relative", width: "735px", height: "1038px" }}
            ref={pdfRef}
            id="pdfdoc"
          >
            {userData && (
              <div style={{ fontFamily: "Arial", margin: "20px" }}>
                <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
                  User Information
                </h1>
                <hr />
                <div style={{ marginBottom: "20px" }}>
                  <p>
                    <strong>ID:</strong> {userData.uniqueID}
                  </p>
                  <p>
                    <strong>Name:</strong> {userData.firstName} {userData.lastName}
                  </p>
                  <p>
                    <strong>Organization:</strong> {userData.organization}
                  </p>
                </div>
                <h2 style={{ marginBottom: "10px" }}>Traits Scores</h2>
                <hr />
                <div style={{ marginBottom: "20px" }}>
                  <p>
                    <strong>Extraversion:</strong>{" "}
                    {userData.traits_scores.Extraversion}
                  </p>
                  <p>
                    <strong>Openness:</strong> {userData.traits_scores.Openness}
                  </p>
                  <p>
                    <strong>Agreeableness:</strong>{" "}
                    {userData.traits_scores.Agreeableness}
                  </p>
                  <p>
                    <strong>Neuroticism:</strong>{" "}
                    {userData.traits_scores.Neuroticism}
                  </p>
                  <p>
                    <strong>Conscientiousness:</strong>{" "}
                    {userData.traits_scores.Conscientiousness}
                  </p>
                </div>
                <h2 style={{ marginBottom: "10px" }}>Skills Scores</h2>
                <hr />
                <div style={{ marginBottom: "20px" }}>
                  <p>
                    <strong>Technical Skill:</strong>{" "}
                    {userData.skills_scores.Technical_Skill}
                  </p>
                  <p>
                    <strong>Human Skill:</strong>{" "}
                    {userData.skills_scores.Human_Skill}
                  </p>
                  <p>
                    <strong>Conceptual Skill:</strong>{" "}
                    {userData.skills_scores.Conceptual_Skill}
                  </p>
                </div>
                <h2 style={{ marginBottom: "10px" }}>Interests Scores</h2>
                <hr />
                <div>
                  <p>
                    <strong>Top Section 1:</strong>{" "}
                    {userData.interests_scores.topSection1}
                  </p>
                  <p>
                    <strong>Top Section 2:</strong>{" "}
                    {userData.interests_scores.topSection2}
                  </p>
                  <p>
                    <strong>Top Section 3:</strong>{" "}
                    {userData.interests_scores.topSection3}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default PsychometricPDFReport;
